import React from "react";

const therapyTopics = [
  "Mood Disorders",
  "Anxiety & Related Disorders",
  "Suicidal Tendencies",
  "Stress Management",
  "Trauma & Abuse-related Issues",
  "Substance Abuse",
  "Personality Disorders",
  "Anger Management",
  "Obsessive Compulsive Disorder (OCD)",
  "LGBTQIA+ Support",
  "Confidence & Self-esteem Building",
  "Assertiveness Training",
  "Family related Conflicts",
  "Emotional First Aid",
  "Coping with Life Transitions",
  "Work/Corporate related Concerns",
  "Adolescent Specific Concerns (peer pressure, body image issues, study skills)",
  "Parenting Strategies",
  "Self Development",
  "Couple Counseling",
  "Family Counseling",
  "Parental Consultation",
];

const TherapyCards = () => {
  return (
    <div className="therapy-cards-container">
      {therapyTopics.map((topic, index) => (
        <div key={index} className="therapy-card">
          {topic}
        </div>
      ))}
    </div>
  );
};

export default TherapyCards;
